import Marquee from "react-fast-marquee";

// Slow editorial marquee — huge outlined Playfair serif acting as a texture.
export default function EditorialMarquee({
  text = "Dim Sum · Hand-Pulled Noodles · Wok Classics ·",
  className = "",
}) {
  return (
    <div
      className={`select-none border-y border-brand-ink/10 bg-brand-cream py-8 md:py-12 ${className}`}
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <Marquee speed={38} gradient={false} autoFill>
        <span className="font-display text-6xl md:text-8xl lg:text-9xl leading-none text-stroke pr-10">
          {text}
        </span>
      </Marquee>
    </div>
  );
}
